module.exports = __webpack_public_path__ + "f48017a736795695691baddeb761f5e8.hdr";